import { Component, OnInit, Input } from '@angular/core';
import { Investor } from '../../shared/models/investor';
import * as _ from 'lodash';

@Component({
  selector: 'app-goal-details',
  templateUrl: './goal-details.component.html',
  styleUrls: ['./goal-details.component.css'],
})
export class GoalDetailsComponent implements OnInit {
  targetValue = 0;
  selected_goals = {};
  goalTypes = [];
  selectedGoalType: string;

  @Input() investor: Investor;
  @Input() flags: any;

  constructor() {
    this.goalTypes = Object.assign([], available_goals);
  }

  ngOnInit() {
    this.selected_goals = this.investor.goals || {};
    if (this.selected_goals.hasOwnProperty('home')) {
      this.selectedGoalType = 'home';
    }
  }

  selectGoal(type) {
    if (!this.selected_goals.hasOwnProperty(type)) {
      this.selected_goals[type] = [];
      this.addGoal(type);
    } else {
      if (this.selected_goals[type].length == 0) {
        this.selected_goals[type] = [];
        this.addGoal(type);
      }
    }
    this.selectedGoalType = type;
  }
  // selectGoal(type) {
  //   const wanted_goals = this.goalTypes.filter((goal) => goal.label === type);
  //   if (this.selected_goals.filter((goal) => goal.label === type).length <= 0) {
  //     this.selected_goals.push(wanted_goals[0]);
  //   } else {
  //     this.selected_goals = this.selected_goals.filter((goal) => goal.label !== type);
  //   }

  // }

  addGoal(type) {
    const goalTemplate = this.goalTypes.filter((g) => g.goal_type === type)[0];
    const objToPush = Object.assign({}, goalTemplate);
    this.selected_goals[type].push(objToPush);
  }
  removeGoal(type, item) {
    this.selected_goals[type] = this.selected_goals[type].filter(
      (g) => g !== item,
    );
  }

  onTargetValueChange(data) {
    this.targetValue = data;
  }

  getInflationAmount(item) {
    const inflation_rate = item.inflation_rate;
    const principal = item.target_amount || 0;
    const time = item.target_time || 0;
    const inflationAmount = Math.round(
      principal * (1 + inflation_rate / 100.0) ** time,
    );
    item.inflation_amount = inflationAmount;
    this.calculateAndGetLumpsumAmount(item);
    this.calculateAndGetSIP(item);
    return inflationAmount;
  }

  getTotalFinancialAssetsAfterGoalRemoval() {
    const totalFinancialGoals = Object.keys(this.selected_goals)
      .filter((k) => k !== 'retirement')
      .map((k) => this.selected_goals[k])
      .reduce((a, b) => a.concat(b), [])
      .map((item) => item.target_amount)
      .reduce((a, b) => a + b, 0);
    const invTotalLiquid =
      this.investor.total_liquid_assets_value - totalFinancialGoals;
    const invTotalFinancial = this.investor.total_financial_assets_value;
    if (invTotalLiquid <= 0) {
      return invTotalFinancial + invTotalLiquid;
    }
    return invTotalFinancial;
  }

  getTotalLiquidAssetsAfterGoalRemoval() {
    const totalLiquidGoals = Object.keys(this.selected_goals)
      .filter((k) => k !== 'retirement')
      .map((k) => this.selected_goals[k])
      .reduce((a, b) => a.concat(b), [])
      .map((item) => item.target_amount)
      .reduce((a, b) => a + b, 0);
    const invTotalLiquid = this.investor.total_liquid_assets_value;
    return invTotalLiquid - totalLiquidGoals > 0
      ? invTotalLiquid - totalLiquidGoals
      : 0;
  }

  getTotalRetirementAssetsAfterGoalRemoval() {
    const totalRetirementGoals = Object.keys(this.selected_goals)
      .filter((k) => k === 'retirement')
      .map((k) => this.selected_goals[k])
      .reduce((a, b) => a.concat(b), [])
      .map((item) => item.target_amount)
      .reduce((a, b) => a + b, 0);
    const invTotalRetirement = this.investor.total_retirement_assets_value;
    return invTotalRetirement - totalRetirementGoals > 0
      ? invTotalRetirement - totalRetirementGoals
      : 0;
  }

  getAssetsScore() {
    this.investor.assets_income_score =
      this.investor.total_liquid_assets_value / this.investor.total_income;
    return this.investor.assets_income_score || 0;
  }

  calculateAndGetLumpsumAmount(item) {
    const weighted_average = 0;
    const la_fa_total =
      this.investor.total_financial_assets_value +
      this.investor.total_liquid_assets_value +
      this.investor.total_marketable_assets_value;
    // tslint:disable-next-line:max-line-length
    const other_total =
      this.investor.total_personal_assets_value +
      this.investor.total_retirement_assets_value +
      this.investor.total_tangile_assets_value;
    const la_fa_wa = this.investor.liquid_financial_weighted_average;
    // tslint:disable-next-line:max-line-length
    const other_wa = this.investor.other_assets_weighted_average;

    const total_assets_amount = la_fa_total + other_total * 0.1;
    // total_assets_amount = 90000 + 15000
    const total_wa =
      ((la_fa_total / total_assets_amount) * la_fa_wa +
        ((other_total * 0.1) / total_assets_amount) * other_wa) /
      100;
    // total_wa = (90000/105000 * 2.33 + 15000/105000 * 1.45)/100
    const lumpsum_amount =
      item.inflation_amount / (1 + total_wa) ** item.target_time || 0;
    item.lumpsum_amount = Math.round(lumpsum_amount);
    return item.lumpsum_amount;
  }
  calculateAndGetSIP(item) {
    const sip_amount = this.calculateSIP(
      item.inflation_rate / 100 / 12,
      item.target_time * 12,
      item.target_amount,
      item.inflation_amount,
    );
    item.sip_amount = sip_amount;
    item.sip_amount_annual = sip_amount * 12;
    return item.sip_amount;
  }

  calculateSIP(ir, np, pv, fv) {
    /*
     * ir   - interest rate per month
     * np   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    return (
      Math.round(
        (ir * -pv * Math.pow(1 + ir, np)) / (1 - Math.pow(1 + ir, np)),
      ) || 0
    );
  }

  decrementTime(item) {
    let t = parseInt(item.target_time);
    if (t > 0) {
      t = t - 1;
      item.target_time = t + '';
    }
  }
  incrementTime(item) {
    let t = parseInt(item.target_time);
    t = t + 1;
    item.target_time = t + '';
  }
  decrementPriority(item) {
    let t = parseInt(item.priority);
    if (t > 0) {
      t = t - 1;
      item.priority = t + '';
    }
  }
  incrementPriority(item) {
    let t = parseInt(item.priority);
    t = t + 1;
    item.priority = t + '';
  }

  getMonthlyBalance() {
    return Math.round(this.investor.total_investing_SIP_amount / 12) || '';
  }
  updateInvestorGoals() {
    this.investor.goals = this.selected_goals;
    Object.keys(this.investor.goals).map(itemKey=>{
      this.investor.goals[itemKey] = _.filter(this.investor.goals[itemKey], goal=> goal.target_amount != null)
    })
  }
}

const available_goals = [
  {
    label: 'Having my own house',
    icon: 'assets/icons/home-1@2x.png',
    goal_type: 'home',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 10,
    inflation_amount: null,
    target_values: [
      {
        label: '30LAC',
        value: '3000000',
      },
      {
        label: '50LAC',
        value: '5000000',
      },
      {
        label: '70LAC',
        value: '7000000',
      },
      {
        label: '1CR',
        value: '10000000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
  {
    label: 'Educating my children',
    icon: 'assets/icons/Education@2x.png',
    goal_type: 'education',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 15,
    inflation_amount: null,
    target_values: [
      {
        label: '20LAC',
        value: '2000000',
      },
      {
        label: '35LAC',
        value: '3500000',
      },
      {
        label: '60LAC',
        value: '6000000',
      },
      {
        label: '80LAC',
        value: '8000000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
  {
    label: 'Buying my dream car',
    icon: 'assets/icons/car@2x.png',
    goal_type: 'car',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 7,
    inflation_amount: null,
    target_values: [
      {
        label: '5LAC',
        value: '500000',
      },
      {
        label: '8LAC',
        value: '800000',
      },
      {
        label: '14LAC',
        value: '1400000',
      },
      {
        label: '25LAC',
        value: '2500000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
  {
    label: 'Save money for retirement',
    icon: 'assets/icons/retirement@2x.png',
    goal_type: 'retirement',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 8,
    inflation_amount: null,
    target_values: [
      {
        label: '50LAC',
        value: '5000000',
      },
      {
        label: '70LAC',
        value: '7000000',
      },
      {
        label: '1CR',
        value: '10000000',
      },
      {
        label: '3CR',
        value: '30000000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
  {
    label: 'Target value',
    icon: 'assets/icons/Target@2x.png',
    goal_type: 'target_sum',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 8,
    inflation_amount: null,
    target_values: [
      {
        label: '50LAC',
        value: '5000000',
      },
      {
        label: '1CR',
        value: '10000000',
      },
      {
        label: '5CR',
        value: '50000000',
      },
      {
        label: '10CR',
        value: '100000000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
  {
    label: 'Other',
    icon: 'assets/icons/other@2x.png',
    goal_type: 'other_goal',
    target_amount: null,
    target_time: 1,
    priority: 1,
    inflation_rate: 8,
    inflation_amount: null,
    target_values: [
      {
        label: '50LAC',
        value: '5000000',
      },
      {
        label: '1CR',
        value: '10000000',
      },
      {
        label: '5CR',
        value: '50000000',
      },
      {
        label: '10CR',
        value: '100000000',
      },
    ],
    lumpsum_amount: null,
    sip_amount: null,
  },
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/goal-details/goal-details.component.ts